<template>
    <student-backend-focus-layout
        header-bg-color="white"
        content-bg-color="white"
        exit-button-text="Exit to dashboard"
        v-on:exit-page-clicked="exitToDashboard"
        :page-title="pageTitle"
    >
        <template #page_header>
            <div class="border-b border-gray-300 pb-4 pt-4">
                <div
                    v-if="catAttempt.result !== 'PASSED'"
                    class="mx-auto flex max-w-2xl flex-col items-center justify-center gap-4 text-center"
                >
                    <div class="">
                        <svg
                            width="42"
                            height="42"
                            viewBox="0 0 42 42"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="21"
                                cy="20.75"
                                r="20.75"
                                fill="#E25941"
                            />
                            <g clip-path="url(#clip0_1326_28809)">
                                <path
                                    d="M19.1315 14.019C18.7893 13.9273 18.4204 14.0321 18.2101 14.3175C17.7452 14.947 17.403 15.6583 17.2012 16.4144C16.8237 17.8235 16.959 19.2475 17.4914 20.4913C17.5715 20.6785 17.725 20.8206 17.8888 20.9404C18.2302 21.1898 18.4945 21.5463 18.6654 21.9459C19.0767 22.9108 19.685 23.7793 20.4512 24.4957C20.9505 24.9608 21.332 25.5567 21.4122 26.2332C21.4688 26.7073 21.4344 27.1878 21.3107 27.649L21.1742 28.1587C21.1312 28.3188 21.1537 28.4895 21.2366 28.6331C21.3195 28.7767 21.4561 28.8815 21.6162 28.9244C22.0967 29.0531 22.6087 28.9857 23.0395 28.737C23.4703 28.4883 23.7846 28.0786 23.9134 27.5981C24.1619 26.6705 24.188 25.736 24.0255 24.851C23.9317 24.3443 24.3883 23.8418 24.8859 23.9752L27.4029 24.6496C28.229 24.871 29.1187 24.5104 29.4268 23.7119C29.5541 23.3818 29.6649 23.0421 29.7588 22.6918C30.3525 20.4894 30.1724 18.15 29.2485 16.0644C29.0401 15.5926 28.611 15.2645 28.1134 15.1312L24.8798 14.2647C24.4909 14.1605 24.0867 14.1195 23.6844 14.1429L20.9526 14.3085C20.5502 14.3323 20.1465 14.2912 19.7572 14.1866L19.1315 14.019ZM13.2981 19.1641C13.1566 17.9173 13.2515 16.6551 13.5778 15.4435C13.8332 14.4864 14.2293 13.5726 14.7532 12.7319C15.1459 12.1036 15.9212 11.8643 16.637 12.0561L17.3673 12.2518C17.7256 12.3478 17.8396 12.8081 17.5947 13.0877C16.8367 13.9521 16.2885 14.9797 15.9926 16.0906C15.6241 17.4658 15.6628 18.8544 16.0343 20.1285C16.1446 20.5059 15.8048 20.8947 15.4248 20.7928L14.5785 20.5661C13.9086 20.3866 13.3775 19.8533 13.2981 19.1641Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_1326_28809">
                                    <rect
                                        width="20.0064"
                                        height="20.0064"
                                        fill="white"
                                        transform="matrix(0.965926 0.258819 0.258819 -0.965926 9.05273 27.5)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="text-[18px] font-semibold text-gray-800">
                        Unfortunately, you did not pass
                    </div>
                    <div class="text-[16px] text-gray-600">
                        In order to pass the qAdapt simulation exam you must
                        achieve a passing score in each of the five NREMT focus
                        areas. Passing this test and having a Readiness Score
                        above 90 are good indicators that you’re ready to sit
                        for your certifying exam.
                    </div>
                </div>
                <div
                    v-else
                    class="mx-auto flex max-w-2xl flex-col items-center justify-center gap-4 text-center"
                >
                    <div class="">
                        <svg
                            width="42"
                            height="42"
                            viewBox="0 0 42 42"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="21" cy="21" r="21" fill="#1F9294" />
                            <g clip-path="url(#clip0_1326_28918)">
                                <path
                                    d="M19.1095 27.1567C18.7632 27.2495 18.3898 27.1435 18.177 26.8546C17.7065 26.2176 17.3601 25.4977 17.1559 24.7325C16.7738 23.3064 16.9108 21.8653 17.4496 20.6064C17.5307 20.417 17.6861 20.2732 17.8518 20.1519C18.1973 19.8995 18.4649 19.5387 18.6377 19.1343C19.0541 18.1578 19.6696 17.2789 20.4451 16.5539C20.9504 16.0831 21.3365 15.48 21.4177 14.7954C21.475 14.3156 21.4401 13.8293 21.315 13.3626L21.1768 12.8467C21.1333 12.6846 21.1561 12.5119 21.24 12.3666C21.3239 12.2213 21.4621 12.1152 21.6242 12.0718C22.1104 11.9415 22.6286 12.0097 23.0645 12.2614C23.5005 12.5131 23.8187 12.9277 23.949 13.414C24.2005 14.3528 24.2269 15.2986 24.0625 16.1942C23.9675 16.707 24.4296 17.2156 24.9332 17.0806L27.4805 16.3981C28.3166 16.174 29.2171 16.5389 29.5288 17.3471C29.6576 17.6812 29.7698 18.0249 29.8648 18.3794C30.4657 20.6083 30.2834 22.976 29.3484 25.0867C29.1374 25.5642 28.7032 25.8962 28.1996 26.0312L24.927 26.9081C24.5334 27.0135 24.1244 27.055 23.7172 27.0314L20.9525 26.8638C20.5452 26.8396 20.1367 26.8813 19.7427 26.9871L19.1095 27.1567ZM13.2058 21.9497C13.0626 23.2114 13.1586 24.4889 13.4889 25.715C13.7473 26.6837 14.1482 27.6085 14.6784 28.4593C15.0759 29.0952 15.8605 29.3374 16.5849 29.1433L17.324 28.9453C17.6867 28.8481 17.802 28.3822 17.5541 28.0993C16.7871 27.2245 16.2322 26.1845 15.9328 25.0602C15.5598 23.6684 15.599 22.263 15.975 20.9736C16.0866 20.5917 15.7427 20.1982 15.3581 20.3013L14.5017 20.5308C13.8237 20.7125 13.2861 21.2521 13.2058 21.9497Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_1326_28918">
                                    <rect
                                        width="20.2474"
                                        height="20.2474"
                                        fill="white"
                                        transform="translate(8.90918 13.5137) rotate(-15)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="text-[18px] font-semibold text-gray-800">
                        Congrats you passed!
                    </div>
                    <div class="text-[16px] text-gray-600">
                        You achieved a passing score in each of the five NREMT
                        focus areas on our qAdapt simulation exam. The goal of
                        this computer adaptive test (CAT) is to expose you to a
                        similar format and style of questions that you’ll see on
                        test day. Passing this test and having a Readiness Score
                        above 90 are good indicators that you’re ready to sit
                        for your certifying exam.
                    </div>
                </div>
            </div>
        </template>
        <template #content>
            <div class="mx-auto flex w-full flex-col gap-4">
                <div
                    v-if="catAttempt.result !== 'PASSED'"
                    class="my-4 flex items-start gap-4 rounded border border-primary-450 bg-primary-250 p-4"
                >
                    <div class="">
                        <svg
                            width="24"
                            height="26"
                            viewBox="0 0 24 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12 25C17.5228 25 22 20.5228 22 15C22 9.47715 17.5228 5 12 5C6.47715 5 2 9.47715 2 15C2 20.5228 6.47715 25 12 25Z"
                                stroke="#5485D1"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M12 11V15"
                                stroke="#5485D1"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M12 19H12.01"
                                stroke="#5485D1"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <div class="text-[16px] text-gray-700">
                        <span class="font-semibold">Note:</span> Passing is not
                        only based on your raw percentage score, but also on the
                        difficulty of the questions that you answered correctly.
                    </div>
                </div>
                <div class="flex flex-col gap-4">
                    <div class="font-semibold">Summary</div>
                    <div class="flex">
                        <div class="w-44 flex-none">Date:</div>
                        <div class="">
                            {{
                                dayjs(catAttempt.started_at)
                                    .utc(false)
                                    .tz($page.props.display_timezone)
                                    .format($page.props.date_formats.full_nice)
                            }}
                        </div>
                    </div>
                    <div class="flex">
                        <div class="w-44 flex-none">Total time:</div>
                        <div class="">{{ catAttempt.time_spent }} minutes</div>
                    </div>
                    <div class="flex">
                        <div class="w-44 flex-none">Level:</div>
                        <div class="">
                            {{ $page.props.auth.user.provider_level.title }}
                        </div>
                    </div>
                </div>
                <div class="">
                    <table class="table w-full text-[16px]">
                        <thead>
                            <th>Focus Area</th>
                            <th># Correct / Total</th>
                            <th>Result</th>
                            <th></th>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(
                                    focusAreaPerformance, focusAreaId
                                ) in catAttempt.focus_areas_performance"
                                class="border-b border-gray-400 even:bg-gray-200"
                            >
                                <td>{{ getFocusArea(focusAreaId).title }}</td>
                                <td>
                                    {{ focusAreaPerformance.correct }} /
                                    {{ focusAreaPerformance.attempted }}
                                </td>
                                <td>
                                    <span
                                        v-if="
                                            focusAreaPerformance.result ==
                                            'FINISHED-PASSED'
                                        "
                                        class="inline-block w-14 rounded border border-green-400 p-2 text-center font-medium text-green-400"
                                    >
                                        Pass
                                    </span>
                                    <span
                                        v-else
                                        class="inline-block w-14 rounded border border-red-500 p-2 text-center font-medium text-red-500"
                                        >Fail</span
                                    >
                                </td>
                                <td class="text-right">
                                    <Link
                                        v-if="focusAreaPerformance.attempted"
                                        :href="
                                            route(
                                                'student.computer-adaptive-test.show-cat-review-focus-area',
                                                {
                                                    cat_attempt: catAttempt.id,
                                                    focus_area: focusAreaId,
                                                }
                                            )
                                        "
                                        class="inline-block rounded border border-primary-500 p-2 text-center font-medium text-primary-500 hover:cursor-pointer hover:bg-primary-500/10"
                                        >Review Answers
                                    </Link>
                                    <span
                                        v-else
                                        class="hover:bg-primary-gray/10 inline-block rounded border border-gray-500 p-2 text-center font-medium text-gray-500 hover:cursor-not-allowed"
                                        >Review Answers
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </student-backend-focus-layout>
</template>

<script>
import StudentBackendFocusLayout from "@/_Layouts/NewStudentBackendFocusLayout.vue";
import StudentQuizQuestionAnswer from "@/Components/StudentQuizQuestionAnswer.vue";
import ConfirmDialog from "@/Components/ConfirmDialog.vue";
import dayjs from "dayjs";

export default {
    name: "StudentComputerAdaptiveTestReview",
    components: {
        ConfirmDialog,
        StudentQuizQuestionAnswer,
        StudentBackendFocusLayout,
    },
    props: {
        catAttempt: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    methods: {
        dayjs,
        exitToDashboard: function () {
            this.$inertia.get(route("student.dashboard"));
        },
        getFocusArea(focusAreaId) {
            let focusArea = _.find(
                this.$page.props.focusAreas,
                function (focusArea) {
                    return focusArea.id == focusAreaId;
                }
            );

            return focusArea;
        },
    },
    computed: {
        pageTitle() {
            return (
                "Computer Adaptive Test Review - " +
                this.$page.props.auth.user.provider_level.title
            );
        },
        quizStartTime() {
            return dayjs(this.catAttempt.started_at);
        },
        quizEndTime() {
            return dayjs(this.catAttempt.completed_at);
        },
    },
    mounted() {},
};
</script>

<style scoped></style>
